import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Titre from '../UI/Titre.jsx'
import Description from '../UI/Description.jsx';
import Remerciement from '../UI/Remerciement.jsx';
import AudioRecorder from '../UI/AudioRecorder.jsx';
import Consent from '../UI/Consent.jsx';
import DonneesPersonnelles from '../UI/DonneesPersonnelles.jsx';
import Compteur from '../UI/Compteur.jsx';
import { useCallback } from 'react';
import { ManageCompteur } from '../Services/ManageCompteur.jsx';
import Accueil from '../UI/Accueil.jsx';

function VOC000100({
    interaction,
    afficherAccueil,
    afficherEtapeCollecteParticipation,
    afficherEtapeRemerciement,
    afficherEtapeGRPD,
    afficherEtapeCollectInformationsPersonnelles,
    changerAfficherEtapeCollecteParticipation,
    changerEtapeRemerciement,
    changerEtapeCollecteParticipationVocale,

    setContinueEnabled,
    continueEnabled,

    audioBlob,
    setAudioBlob,
    audioURL,
    setAudioURL,
    sendRecordParticipation,
    sendingParticipationState,


    setConsent,
    consentGDPR,
    consentImage,
    passerEtapeRGPDEnabled,
    setRememberMe,
    setField,
    saveDonneePersonnelle,
    setMessageErreur,
    retourAccueil,
}) {

    const {
        counter,
        startCountdownTimer,
        stopCountdownTimer,
        afficherCompteur,
        setAfficherCompteur,
    } = ManageCompteur(interaction);

    const handleStartRecording = useCallback(
        (status) => {
            if (status === 'start') {
                startCountdownTimer();
            }
            if (status === 'stop') {
                stopCountdownTimer();
                setAfficherCompteur(true);
            }
        },
        [setAfficherCompteur, startCountdownTimer, stopCountdownTimer]
    );

    const handleAfficherCompteur = useCallback(
        () => {
            setAfficherCompteur(true);
        }, [setAfficherCompteur]
    );

    return (
        <>
            <Row className="custom-instructions">
                <Col>
                    <Titre interaction={interaction} />
                </Col>
            </Row>
            {afficherAccueil &&
                // Page d accueil
                <>
                    <Accueil
                        interaction={interaction}
                        changerPage={changerAfficherEtapeCollecteParticipation}
                    />
                </>
            }
            {afficherEtapeCollecteParticipation &&
                // Page de collecte de participation (limité à 1 vote ou non)
                <>
                    <Row className="custom-instructions">
                        <Col>
                            <Description interaction={interaction} />
                        </Col>
                    </Row>

                    {afficherCompteur && audioURL === '' &&
                        <>
                            <Row>
                                <Col>
                                    <Compteur counter={counter} />
                                </Col>
                            </Row>
                        </>
                    }

                    <Row className="custom-collecte-participation">
                        <Col>

                            <AudioRecorder
                                audioURL={audioURL}
                                setAudioURL={setAudioURL}
                                audioBlob={audioBlob}
                                sendingParticipationState={sendingParticipationState}
                                setMessageErreur={setMessageErreur}
                                setAudioBlob={setAudioBlob}
                                maxRecordingTime={interaction.max_recording_time}
                                onStartRecording={handleStartRecording}
                                changerEtapeCollecteParticipationVocale={changerEtapeCollecteParticipationVocale}
                                onRestartRecording={handleAfficherCompteur}

                            />
                        </Col>
                    </Row>
                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>
                </>
            }
            {afficherEtapeCollectInformationsPersonnelles &&
                <>
                    <DonneesPersonnelles interaction={interaction} setField={setField} setRememberMe={setRememberMe} />
                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>
                </>
                // Page de collecte de données personnelles
            }
            {afficherEtapeGRPD &&
                <>
                    <Consent
                        customisation={interaction.segment_customisation}
                        consentGDPR={consentGDPR}
                        consentImage={consentImage}
                        setConsent={setConsent}
                    />
                    <Row className="custom-commandes">
                        <Col>
                            <Button onClick={changerEtapeRemerciement} disabled={!passerEtapeRGPDEnabled}>Continuer</Button>
                        </Col>
                    </Row>
                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>
                </>
                // Page de consentement
            }
            {afficherEtapeRemerciement &&
                <>
                    <Row className="custom-commandes">
                        <Col>
                            <Remerciement interaction={interaction} >Continuer</Remerciement>
                        </Col>
                    </Row>

                </>
                // Page de remerciemeent
            }
        </>
    )
}
export default VOC000100;
